module.exports = __webpack_public_path__ + "img/stickers-recepisse-PACS.8891c55d.jpg";